<div class="selfie-verification-container">
  <div *ngIf="verificationCompleted" class="verification-success-message my-3">
    <div class="alert alert-success border-0">
      <div class="d-flex align-items-center">
        <i class="icon-check me-2" style="color: #28a745"></i>
        <span
          ><strong
            >{{ 'Face ID verification passed successfully' | translate }}
          </strong></span
        >
      </div>
    </div>
  </div>

  <div *ngIf="!verificationCompleted">
    <div
      *ngIf="field.props?.['descriptionText']"
      class="selfie-instructions mb-4">
      <div [innerHTML]="field.props['descriptionText'] | translate"></div>
    </div>
    <button
      type="button"
      class="btn btn-primary w-100"
      [disabled]="field.props?.['isButtonDisabled'] === true"
      [class.btn-primary-disabled]="field.props?.['isButtonDisabled'] === true"
      (click)="openVerificationModal()">
      {{ field.props['buttonText'] || 'Open camera' | translate }}
    </button>
  </div>
</div>
